<div class="dialog delete">
  <div mat-dialog-title class="dialogHeader">
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content class="content">
    <div>
        <span> 
         Are you a Microsoft full-time employee?
        </span>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="footer">
    <button mat-flat-button class="flat-button" (click)="FTEYesAction()">YES</button>
    <button mat-flat-button class="flat-button" (click)="FTENoAction()">NO</button>
  </div>
</div>